﻿export const openDayTime: object = {
  opendaytimeFormat: "{0}: {1}",
  opendaytimeSeperator: "\r\n",
  opentimeFormat: "HH:mm",
  opentimeFormatSmart: "H",
  opentimeCombine: "{0} - {1} Uhr",
  opentimeCombineWithoutColockLabel: "{0} - {1}",
  opendayCombine: "{0} - {1}",
  opentimeSeperator: ",\r\n",
  weekdayMarker: ">> {0} <<",

  phClosed: "geschlossen",
  phMondayFull: "Montag",
  phMonday: "Mo.",
  phTuesdayFull: "Dienstag",
  phTuesday: "Di.",
  phWednesdayFull: "Mittwoch",
  phWednesday: "Mi.",
  phThursdayFull: "Donnerstag",
  phThursday: "Do.",
  phFridayFull: "Freitag",
  phFriday: "Fr.",
  phSaturdayFull: "Samstag",
  phSaturday: "Sa.",
  phSundayFull: "Sonntag",
  phSunday: "So."
};
